import { render, staticRenderFns } from "./DoctorTitle.vue?vue&type=template&id=65d014b5&scoped=true&"
import script from "./DoctorTitle.vue?vue&type=script&lang=js&"
export * from "./DoctorTitle.vue?vue&type=script&lang=js&"
import style1 from "./DoctorTitle.vue?vue&type=style&index=1&id=65d014b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d014b5",
  null
  
)

export default component.exports